import CommunicationCountItem from './CommunicationCountItem';

export default CommunicationCountItem;
